import React, { useState } from 'react';
import CircleButton, {
  getCircleButtonClass,
} from 'components/v2/buttons/CircleButton';
import { ClipboardDocumentIcon } from '@heroicons/react/24/solid';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import BulkAddAccessorialsModal from 'components/modules/shipments/accounting/BulkAddAccessorialsModal';

const fscAccessorialTypes = {
  FSC: 'fuel_surcharge',
};

export default function AddAccessorialNextStep({ item, shipment }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const renderIcon = () => {
    return !item.complete ? (
      <ClipboardDocumentIcon type="solid" className="w-5 h-5" />
    ) : (
      <div className={getCircleButtonClass({ size: 'small', color: 'brand' })}>
        <CheckIcon />
      </div>
    );
  };

  return (
    <div>
      <div className="flex justify-between text-sm text-gray-700  py-1 items-center">
        <span>{t(sluggify(item.field))}</span>
        <CircleButton
          size="small"
          disabled={item.complete}
          onClick={() => setShowModal(true)}
        >
          {renderIcon()}
        </CircleButton>
      </div>
      {showModal && (
        <BulkAddAccessorialsModal
          show={showModal}
          orderId={shipment.order._id || null}
          shipmentIds={[shipment.id]}
          onHide={() => setShowModal(false)}
          defaultAccessorialType={fscAccessorialTypes.FSC}
        />
      )}
    </div>
  );
}
